(function ($) {
	$(document).ready(function () {
		$(".mobile-slider .e-con-inner").slick({
			dots: true,
			infinite: false,
			speed: 300,
			slidesToShow: 1,
			arrows: false,
			mobileFirst: true,

			responsive: [
				// {
				//     breakpoint: 600,
				//     slidesToShow: 2,

				// },
				{
					breakpoint: 600,
					settings: "unslick",
				},
			],
		});

		$(".we-work-with-1").slick({
			autoplay: true,
			autoplaySpeed: 3000, // Pause for 3 seconds after showing 4 items
			speed: 5000,
			arrows: false,
			swipe: false,
			infinite: true,
			slidesToShow: 7,
			cssEase: "ease-in-out", // Change easing to ease-in-out for acceleration and deceleration
			pauseOnFocus: false,
			pauseOnHover: false,
			slidesToScroll: 4,
			responsive: [
				{
					breakpoint: 1366,
					settings: {
						slidesToShow: 5,
						slidesToScroll: 4,
					},
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 4,
					},
				},
			],
		});

		$(".we-work-with-2").slick({
			autoplay: true,
			autoplaySpeed: 3000, // Pause for 3 seconds after showing 4 items
			speed: 5000,
			arrows: false,
			swipe: false,
			infinite: true,
			slidesToShow: 7,
			cssEase: "ease-in-out", // Change easing to ease-in-out for acceleration and deceleration
			pauseOnFocus: false,
			pauseOnHover: false,
			slidesToScroll: 4,
			rtl: true, // Invert the slide direction
			responsive: [
				{
					breakpoint: 1366,
					settings: {
						slidesToShow: 5,
						slidesToScroll: 4,
					},
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 4,
					},
				},
			],
		});

		// $(".we-work-with-2").attr("dir", "rtl");

		if ($(".slide-blog-home").length) {
			$(".slide-blog-home .oxy-posts").slick({
				autoplay: true,
				autoplaySpeed: 5000, // Pause for 3 seconds after showing 4 items
				arrows: false,
				swipe: true,
				infinite: true,
				slidesToShow: 5,
				pauseOnFocus: false,
				pauseOnHover: false,
				slidesToScroll: 1,
				dots: true,
				cssEase: "ease-in-out", // Change easing to ease-in-out for acceleration and deceleration
				responsive: [
					{
						breakpoint: 1366,
						settings: {
							slidesToShow: 5,
						},
					},
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 3,
						},
					},
					{
						breakpoint: 600,
						settings: {
							slidesToShow: 2,
						},
					},
				],
			});
		}

		$(window).scroll(function () {
			if ($(this).scrollTop() > $("#_header-2-8").height()) {
				$("#_header-2-8").addClass("active");
			} else {
				$("#_header-2-8").removeClass("active");
			}
		});

		///heder js
		if (window.innerWidth >= 992) {
			function initMenuToggle(scope) {
				let menuItems = scope.find("> li.menu-item-has-children");

				menuItems.each(function () {
					let $item = $(this);

					$item.children("a").click(function (e) {
						e.preventDefault();
						e.stopPropagation();

						let subMenu = $item.children(".sub-menu");

						if ($item.hasClass("active-submenu")) {
							$item.removeClass("active-submenu").css("padding-bottom", "0");

							// Nếu có cha cấp trên => update lại padding cho cha
							updateParentPadding($item);
						} else {
							// Đóng các menu cùng cấp
							menuItems.removeClass("active-submenu").css("padding-bottom", "0");

							let subMenuHeight = subMenu.outerHeight(true);
							$item.addClass("active-submenu").css("padding-bottom", subMenuHeight + "px");

							// Nếu có cha cấp trên => update lại padding cho cha
							updateParentPadding($item);
						}
					});

					// Khởi tạo cho sub-menu cấp dưới nếu có
					let subMenu = $item.children(".sub-menu");
					if (subMenu.length > 0) {
						initMenuToggle(subMenu);
					}
				});
			}

			function updateParentPadding($item) {
				let $parentLi = $item.parents("li.menu-item-has-children").first();
				if ($parentLi.length > 0) {
					let subMenu = $parentLi.children(".sub-menu");
					if (subMenu.length > 0) {
						let totalSubHeight = 0;
						subMenu.children("li").each(function () {
							totalSubHeight += $(this).outerHeight(true);
						});
						$parentLi.css("padding-bottom", totalSubHeight + "px");
					}
				}
			}

			let rootMenu = $(".oxy-header-wrapper .oxy-pro-menu-list");
			initMenuToggle(rootMenu);

			$(document).click(function () {
				$(".oxy-header-wrapper .oxy-pro-menu-list .active-submenu")
					.removeClass("active-submenu")
					.css("padding-bottom", "0");
			});

			$(".oxy-header-wrapper .oxy-pro-menu-list .sub-menu").click(function (e) {
				e.stopPropagation();
			});
		}



		if (window.innerWidth < 992) {
			let menuItem = $(
				".oxy-header-wrapper .oxy-pro-menu-list > li.menu-item-has-children >a",
			);

			menuItem.click(function (e) {
				e.preventDefault();
				console.log(menuItem);

				let $this = $(this).parent("li.menu-item-has-children");
				if ($this.hasClass("active-submenu")) {
					$this.removeClass("active-submenu");
				} else {
					$this.addClass("active-submenu");
				}
			});
		}

		// $(document).on("click", ".oxy-pro-menu .oxy-pro-menu-mobile-open-icon", function () {
		//     if ($(".oxy-pro-menu").hasClass("oxy-pro-menu-open")) {
		//         console.log("click");
		//         $(".oxy-pro-menu-mobile-close-icon").trigger("click");
		//     }
		// });

		if ($(".slick-slider-1item").length) {
			$(".slick-slider-1item").slick({
				dots: true,
				infinite: false,
				speed: 300,
				slidesToShow: 1,
				arrows: false,
				mobileFirst: true,
				adaptiveHeight: true,
			});
		}
		if ($(".our-vision__control__slider").length) {
			$(".our-vision__control__slider").slick({
				dots: true,
				infinite: false,
				speed: 300,
				slidesToShow: 1,
				arrows: false,
				mobileFirst: true,
				fade: true, // Enable fade effect
				cssEase: "linear", // Smooth transition for fade effect
			});

			$(".our-vision__control__item").on("click", function () {
				var index = $(this).index();
				$(".our-vision__control__item").removeClass("active");
				$(this).addClass("active");
				$(".our-vision__control__slider").slick("slickGoTo", index);
			});
		}
	});

	$(".button-animation").each(function () {
		var $this = $(this);
		if ($this.children("span").length === 0) {
			// Avoid duplication
			$this.html("<span>" + $this.html() + "</span>");
		}
	});

	function isInViewport(element) {
		const rect = element.getBoundingClientRect();
		return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <=
			(window.innerHeight || document.documentElement.clientHeight) &&
			rect.right <=
			(window.innerWidth || document.documentElement.clientWidth)
		);
	}
	window.addEventListener("scroll", () => {
		const xomniaText = document.querySelectorAll(".xomniaText-wrapper");

		xomniaText.forEach((el) => {
			const isValid = isInViewport(el);
			if (isValid) {
				el.classList.add("active");
			} else {
				el.classList.remove("active");
			}
		});
	});

	$(window).on("scroll", function () {
		if ($(this).scrollTop() > 92) {
			$(".cases-filter-button").addClass("sticky");
		} else {
			$(".cases-filter-button").removeClass("sticky");
		}
	});
})(jQuery);
